module.exports = __webpack_public_path__ + "img/hamburger.3da3d1b3.svg";